/** Base (light) design tokens. Per-org primary/secondary override at theme build. */
export const COLOR_TOKENS = {
  primary: '#434E5F',
  primaryContrast: '#FFFFFF',
  secondary: '#EE7D3A',
  secondaryContrast: '#FFFFFF',
  backgroundDefault: '#F8FAFC',
  backgroundPaper: '#FFFFFF',
  textPrimary: '#101E33',
  textSecondary: '#6A7587',
  divider: '#D8DFE8',
  error: '#EC4949',
  /** Quiet fill behind hovered list rows (filter options, etc.). */
  optionHover: '#F2F5F8',
  borderRadius: 8,
} as const;

/** Dark-mode neutrals. Org primary/secondary/error carry over unchanged. */
export const COLOR_TOKENS_DARK = {
  backgroundDefault: '#0F172A',
  backgroundPaper: '#1E293B',
  textPrimary: '#E2E8F0',
  textSecondary: '#94A3B8',
  divider: '#334155',
  optionHover: '#2A3648',
} as const;

/**
 * Categorical palette for map boundary overlays. Boundary `type` is
 * admin-defined, so colors are assigned by `buildBoundaryColorMap` and cycle
 * once the list is exhausted. Distinct, map-legible hues — deliberately not the
 * org brand color, which can be any hue and would clash as a category color.
 */
export const BOUNDARY_PALETTE = [
  '#2E5AAC', // blue
  '#2E7D49', // green
  '#C9772F', // orange
  '#7B4EA8', // purple
  '#1F8A8A', // teal
  '#B5417F', // magenta
  '#8A6D1F', // gold
  '#4A4A4A', // slate
] as const;

// Zoned-school boundary highlight. Green, kept out of BOUNDARY_PALETTE.
export const HOME_ZONE_COLOR = '#16A34A';
